import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseAggregateComponent, DecodeTextBoxComponent, ExpandableComponent, LabelledTextBoxComponent } from '@nts/std';
import { MainOrchestratorViewModel, MainViewModel } from '@nts/std/src/testing';
import { NgIf } from '@angular/common';
import { GridComponent } from '@nts/std';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-main',
  templateUrl: './main.component.html',
  standalone: true,
  imports: [
    ExpandableComponent,
    LabelledTextBoxComponent,
    DecodeTextBoxComponent,
    GridComponent,
  ]
})
export class MainComponent extends BaseAggregateComponent<MainViewModel, MainOrchestratorViewModel> {
}
